// extracted by mini-css-extract-plugin
export default {"header-container":"styles_header-container__ke0ny","main-container":"styles_main-container__trRlb"};